import React from 'react';
import ReactDOM from 'react-dom/client';
import { broadcastResponseToMainFrame } from '@azure/msal-browser/redirect-bridge';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { UserProvider } from './context/UserContext';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './auth/msalConfig';

// MSAL renews expired tokens by loading this same app in a hidden iframe whose
// URL carries the auth response from Microsoft. Since msal-browser v5, the page
// in that iframe must broadcast the response back to the main frame itself —
// otherwise the main frame gives up after 10s with a "timed_out" error and the
// user is stuck on the sign-in error screen until they clear site data. When
// this load is that iframe, broadcast the response instead of booting the app.
const authParams = window.location.hash + window.location.search;
const isSilentAuthFrame =
  window.parent !== window &&
  /[#?&](code|error)=/.test(authParams) &&
  authParams.includes('state=');

if (isSilentAuthFrame) {
  broadcastResponseToMainFrame().catch((err) =>
    console.error('[auth] failed to relay silent auth response', err)
  );
} else {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <MsalProvider instance={msalInstance}>
      <AuthProvider>
        <UserProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </UserProvider>
      </AuthProvider>
    </MsalProvider>
  );
}
